<div class="news-count-container">
    <div class="notification"></div>
</div>
